import { prop } from 'ramda';
import React from 'react';
import styled from 'styled-components';

import FlexContainer from 'components/lib/ui/FlexContainer';
import Icon from 'components/lib/ui/Icon';
import Text from 'components/lib/ui/Text';

import { color, spacing } from 'common/lib/theme/dynamic';

const ICON_SIZE_PX = 42;
const CONTAINER_WIDTH_PX = 240;

const Root = styled(FlexContainer).attrs({ center: true, column: true, gap: 'xxsmall' })<{
  width: number;
}>`
  width: ${prop('width')}px;
  margin: ${spacing.xxxxlarge} auto;
  text-align: center;
`;

const CardIcon = styled(Icon).attrs({ size: ICON_SIZE_PX })`
  color: ${color.gray};
  margin-bottom: ${spacing.xxsmall};
`;

type Props = {
  title?: string;
  /**
   * See all icons here: https://www.figma.com/design/L9fPXS4FGLa3GWijfzfM1J/MDS-2.0?node-id=2564-23731&m=dev
   */
  iconName?: string;
  width?: number;
};

const EmptyStateCard: React.FC<React.PropsWithChildren<Props>> = ({
  title = 'No data found',
  iconName,
  width = CONTAINER_WIDTH_PX,
  children,
}) => (
  <Root width={width}>
    {iconName && <CardIcon name={iconName} />}
    <Text weight="medium">{title}</Text>
    <Text size="small">
      <FlexContainer gap="small" column center>
        {children}
      </FlexContainer>
    </Text>
  </Root>
);

export default EmptyStateCard;
